import type { BatchPreviewLinkParams } from "./batch-preview-link.type";

export const buildBatchPreviewLinkSearch = (params: BatchPreviewLinkParams) => {
  const searchParams = new URLSearchParams(
    Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)]))
  );

  return `?${searchParams.toString()}`;
};
